<template>
  <v-divider class="divider-title" v-auto-animate>
    <h3>{{ title }}</h3>
  </v-divider>
</template>

<script>
export default {
  props: {
    title: String,
  },
  name: "DividerTitle",
};
</script>

<style>
hr.divider-title:first-of-type {
  display: none;
} 
</style>
